<template>
    <v-dialog
        v-model="dialog"
        max-width="600"
    >
        <v-card>
            <v-card-title class="headline">
                Quick Do Not Disturb
                <v-icon
                    right
                    style="pointer-events: auto;"
                    v-on:click="onClickShowDNDHelp()"
                >
                    mdi-information-outline
                </v-icon>
            </v-card-title>

            <v-card-text>
                <v-select
                    label="How Long?"
                    :items="getTimeSelections()"
                    v-model="for_minutes"
                >
                </v-select>
                <m-edit-text
                    v-if="for_minutes=='custom_length'"
                    label="Custom Length (in minutes)"
                    :value="custom_length"
                    v-on:input="setDNDTime($event)"
                    help_text="Quick DND settings cannot extend beyond 11:59pm today.
                    If you need to be in DND mode longer, go to Account Settings > Notifications and Do Not Disturb to edit your recurring schedule or add a schedule for a specific date(s)."
                    integer_positive_non_zero
                />

                <v-textarea
                    label="Auto Reply"
                    v-model="auto_reply"
                    hint="If blank, no auto-replies will be sent during this temporary DND period"
                    :persistent-hint="true"
                />

            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                    v-if="in_dnd"
                    text
                    @click="onExitAdHocDND"
                >
                    Exit Do Not Disturb
                </v-btn>

                <v-btn
                    text
                    @click="dialog = false;"
                >
                    Cancel
                </v-btn>

                <v-btn
                    color="primary darken-1"
                    text
                    @click="onOk"
                    :disabled="!isValid()"
                >
                    Ok
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data() {
        return {
            organization_id: null,
            auto_reply: null,
            for_minutes: 0,
            dialog: false,
            custom_length: 30,
            in_dnd: false
        }
    },

    methods: {
        onClickShowDNDHelp()
        {
            this.$rc.alert('Quick Do Not Disturb', 'Completing this dialog will put you in Do Not Disturb mode (DND) right away.' +
                ' When this temporary setting expires, your regular recurring DND settings will resume automatically.');
        },
        setDNDTime(for_minutes)
        {
            this.custom_length = for_minutes;
        },
        getTimeSelections()
        {
            return [
                { 'text' : '15 minutes', 'value' : '15'},
                { 'text' : '1 hour', 'value' : '60'},
                { 'text' : '3 hours', 'value' : '180'},
                { 'text' : 'Rest of the day', 'value' : '1440'},
                { 'text' : 'Custom', 'value' : 'custom_length'},
            ]
        },

        showDialog(organization_id, employee_id, ad_hoc_dnd)
        {
            this.organization_id = organization_id;
            this.employee_id = employee_id;

            if (ad_hoc_dnd)
            {
                this.auto_reply = ad_hoc_dnd.auto_reply;
                this.in_dnd = true;
            }
            else
            {
                this.auto_reply = null;
                this.in_dnd = false;
            }

            this.for_minutes = 0;
            this.custom_length = 30;
            this.dialog = true;
        },

        isValid()
        {
            if ( this.for_time > 0 ) return false;
            return true;
        },

        onExitAdHocDND() {
            let info = {
                'organization_id' : this.organization_id,
                'employee_id' : this.employee_id
            };

            this.$emit('exit_ad_hoc_dnd', info);
            this.dialog = false;
        },

        onOk() {
            this.dialog = false;

            if (this.for_minutes == 'custom_length' && this.custom_length > 0)
            {
                this.for_minutes = this.custom_length;
            }

            let ad_hoc_dnd_info = {
                'employee_id' : this.employee_id,
                'for_minutes' : this.for_minutes,
                'auto_reply' : this.auto_reply,
            };

            this.$emit('update_dnd',ad_hoc_dnd_info);
        }
    },
}
</script>